<template>
<div>
    <div class="bg-white col-span-1 p-6">
            <div class="flex justify-between">
                <div class="flex justify-center items-center">
                    <span :class="['relative flex justify-center items-center w-7 h-7 rounded-full mr-1', ranking.background, ranking.color]"><i :class="ranking.icon"></i></span>
                    <p :class="['', ranking.color]">{{ranking.title}}</p>
                </div>
                <p class="text-costeaGray ml-6 mr-4 text-t12">
                    <span class="text-costeaBlack font-medium">{{page}}</span> de <span>{{getPageNumber()}}</span>
                </p>
                <div class="flex flex-row h-full">
                    <button class="w-10 mr-1 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50" @click="page--, getPageNumber()" v-if="page != 1"><i class="ri-arrow-left-line"></i></button>
                    <button class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray" @click="page++, getPageNumber()" v-show="page < getPageNumber()"><i class="ri-arrow-right-line"></i></button>

                </div>
            </div>
            <div class="mt-4">
                <div class="grid grid-cols-12 py-4 border-gray-100 border-b-2">
                    <span class="text-costeaDarkGray flex text-xs uppercase col-span-9 justify-start items-center">Producto</span>
                    <span class="text-costeaDarkGray flex text-xs uppercase col-span-3 justify-center items-center">Rentabilidad</span>
                </div>
                <div class="h-80 overflow-auto">
                    <div v-for="product in displayedProfit" :key="product.index" class="grid grid-cols-12 py-3 border-gray-100 border-b-2">
                        <div class="col-span-9 flex justify-start items-center">
                            <img :src="product.imageUrl" alt="" class="w-8 mr-2 rounded-md">
                            <span class="text-costeaDarkGray text-t14">{{product.name}}</span>
                        </div>
                        <div class="col-span-3 flex justify-center items-center">
                            <span class="text-costeaDarkGray text-t14 flex justify-center items-center">{{product.profit}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    data(){
        return{
            profitProducts: [],
            page: 1,
            pages:[],
            elementsPerPage: 5,
        }
    },
    computed:{
        ...mapState(['homeContent']),
        displayedProfit(){
			return this.paginate(this.profitProducts);
		}
    },
     props:{
         ranking:Object,
    },
    methods:{
        getProfitProducts(){
            for(let i=1; i<=50; i++){
                let randomNum = Math.floor(Math.random() * (100 - 1)) + 1;
                this.profitProducts.push({
                    imageUrl:"img/perfilCostea.jpg",
                    name:`Casquete ${i}0-P0${i}-AM`,
                    profit: `${randomNum}%`
                })
            }
        },
        setPages(){
			let numberOfPages = Math.ceil(this.profitProducts.length / this.elementsPerPage);
			for (let index = 1; index <= numberOfPages; index++) {
				this.pages.push(index);
                
			}
		},
        paginate(products) {
			let page = this.page;
			let perPage = this.elementsPerPage;
			let from = (page * perPage) - perPage;
			let to = (page * perPage);
			return  products.slice(from, to);
		},
        getPageNumber(){
            return this.pages.length
        }
    },
     created(){
        this.getProfitProducts(),
        this.setPages()
    },
}
</script>

<style>

</style>